__turbopack_context__.v({
  "container": "ThirdPartyIframe-module-scss-module__aEgJqW__container",
  "iframeContainer": "ThirdPartyIframe-module-scss-module__aEgJqW__iframeContainer",
  "loadingIndicator": "ThirdPartyIframe-module-scss-module__aEgJqW__loadingIndicator",
});
